import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    customStatisticDetail: (state) => state.customStatisticDetail,
    customStatisticGroup: (state) => state.customStatisticGroup,
    customGroupBy: (state) => state.customGroupings.customGroup,
    customGroupByOptionally: (state) => state.customGroupings.customGroupByOptionally,
};
